import Controller from "./mainHeader.controller";
import template from "./mainHeader.html";

const mainHeader = {
  template,
  controller: Controller,
};

export default mainHeader;



// WEBPACK FOOTER //
// ./src/components/mainHeader/mainHeader.component.js